import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { getOrderData, OrderData, OrderParams } from 'api/dashboard/_request';
import EcomTotalOrderChat from 'components/charts/e-charts/EcomTotalOrderChat';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

const PRESET_RANGES = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
  { label: 'This Year', value: 'year' },
  { label: 'Custom Range', value: 'custom' }
];

type RangeType = 'today' | 'week' | 'month' | 'year' | 'custom';

const EcomTotalOrders = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const [range, setRange] = useState<RangeType>('year');
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [orderData, setOrderData] = useState<OrderData[] | []>([]);

  useEffect(() => {
    const fetchData = async () => {
      const params: OrderParams = { range, id };

      if (range === 'custom' && startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      try {
        const data = await getOrderData(params);
        setOrderData(data);
      } catch (error) {
        console.error('Failed to fetch order data:', error);
      }
    };

    fetchData();
  }, [range, startDate, endDate]);

  return (
    <>
      <Row className="justify-content-between align-items-center mb-4 g-3 pt-5">
        <Col xs="auto">
          <h3>Total Orders</h3>
          <p className="text-body-tertiary lh-sm mb-0">
            Orders received across all channels
          </p>
        </Col>

        <Col xs={8} sm={4}>
          <Form.Select
            size="sm"
            value={range}
            onChange={e => setRange(e.target.value as RangeType)}
          >
            {PRESET_RANGES.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      {range === 'custom' && (
        <Row className="mb-3 g-3 align-items-start">
          <Col xs={12} sm={6} md={2}>
            <Form.Group controlId="startDate">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate ?? ''}
                onChange={e => setStartDate(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={2}>
            <Form.Group controlId="endDate">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                value={endDate ?? ''}
                onChange={e => setEndDate(e.target.value)}
                min={startDate ?? ''}
              />
            </Form.Group>
          </Col>
        </Row>
      )}

      <div className="h-100">
        <EcomTotalOrderChat data={orderData} range={range} />
      </div>
    </>
  );
};

export default EcomTotalOrders;
